module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/476.9fa198f9.png";